export enum UserRoles {
  SystemAdmin = 'System Admin',
  GstarAdmin = 'Gstar Admin',
  InternalUser = 'Internal User',
  ExternalUser = 'External User',
  CountryAdmin = 'Country Admin',
}
